import { metrics, TheWestSection } from '@news-mono/component-library'
import { StaticRoute, Topic } from '@news-mono/web-common'
import { layout } from '../../../App.routing'
import { billboardLeaderboardMrec } from '../../ad-units'
import { factCheckerSegment } from '../../features/fact-checker/fact-checker-segment'
import {
    electionDayContent,
    preElectionDayContent,
} from '../../home/federal-election-segment'

const socialImage = require('./assets/federal-election-landing-page/fed-elec-social-image-min.png')

const curation = 'federal-election-2022'

export const getFederalElectionRouteInfo =
    (topic: Topic): StaticRoute<TheWestSection> =>
    ({ getAdTargeting, store }) => ({
        kind: 'page',
        heading: topic.title,
        hideHeading: true,
        pageType: 'topic',
        includeFromSectionInMetaDescription: true,
        pageMeta: {
            title: topic.title,
            description: topic.seoDescription,
            seoTitle: topic.seoTitle,
            seoDescription: topic.seoDescription,
            meta: [
                {
                    property: 'og:image',
                    content: socialImage,
                },
                { name: 'twitter:image', content: socialImage },
                {
                    property: 'og:image:height',
                    content: '643',
                },
                {
                    property: 'og:image:width',
                    content: '1224',
                },
                {
                    property: 'og:description',
                    content: topic.seoDescription,
                },
                {
                    property: 'twitter:description',
                    content: topic.seoDescription,
                },
            ],
        },
        adTargeting: getAdTargeting('home', 'default', topic),
        section: 'default',
        compositions: [
            layout.composition({
                type: 'box',
                props: {
                    containerWidth:
                        metrics.thewest.siteMetrics.mainContentWidth,
                    horizontalGutters: 'outerMargin',
                    verticalGutters: ['outerMargin', 'unset'],
                },
                contentAreas: {
                    main: [
                        layout.component({
                            type: 'breaking-news',
                            props: {
                                dataDefinitionArgs: {
                                    type: 'curation',
                                    name: 'breaking-news',
                                    offset: 0,
                                    pageSize: 1,
                                },
                                removeBottomMargin: true,
                            },
                            feature: [
                                'federal-election-2022-landing-page-breaking-strap',
                                true,
                            ],
                        }),
                        // Gradient themed thor with fedelection 2022 theme
                        layout.nestedComposition({
                            type: 'thor',
                            feature: 'federal-election-2022-election-day',
                            props: {
                                hasBackgroundFill: true,
                                containerWidth: '100%',
                                verticalGutters: false,
                                horizontalGutters: true,
                                themeOverride: 'federal-election',
                                verticalSpacing: 'unset',
                                hideHeadingLink: true,
                                hidePollieRaterBanner: true,
                                isHeadingH1: true,
                                layout: 'horizontal',
                            },
                            contentAreas: {
                                main: store.getState().toggles[
                                    'federal-election-2022-election-day-widgets'
                                ]
                                    ? electionDayContent
                                    : preElectionDayContent,
                            },
                        }),

                        // Leaderboard 1
                        ...billboardLeaderboardMrec('one'),

                        layout.component({
                            type: 'pollie-rater-driver-banner',
                            props: {
                                isFixedWidth: false,
                                displayButton: true,
                            },
                            feature: 'federal-election-2022-election-day',
                        }),

                        // Fact checker
                        factCheckerSegment({
                            orientation: 'horizontal',
                        }),
                        // Leaderboard 2
                        ...billboardLeaderboardMrec('two'),
                        // Read more collection
                        layout.component({
                            type: 'lima',
                            props: {
                                verticalSpacing: 'xl',
                                fontScale: 1.2,
                                fixedRatios: ['16:9'],
                                initialColumns: 1,
                                finalColumns: 4,
                                loadMoreEnabled: true,
                                hasBackground: true,
                                cardOrientation: { type: 'Landscape-Portrait' },
                                dataDefinitionArgs: {
                                    type: 'listing',
                                    topics: ['politics/federal-election'],
                                    includeSubTopics: true,
                                    paging: {
                                        page: 1,
                                        pageSize: 8,
                                    },
                                },
                            },
                        }),
                        // Leaderboard 3
                        ...billboardLeaderboardMrec('three'),
                    ],
                },
            }),
        ],
    })
